export default __webpack_public_path__ + "static/media/LilNounsReadingGnarsDAO.4880d96f.png";